import { useEffect, useState } from "react";
import "../Global.js";
import { useConfigsQuery } from "./queries.js";

const useAppImages = () => {
  // eslint-disable-next-line
  const { loading, error, data } = useConfigsQuery();
  const [appImagesData, setAppImagesData] = useState([]);
  const [sectionDetails, setSectionDetails] = useState([]);

  useEffect(() => {
    const processAppImagesData = () => {
      const appImages = {};
      const details = {};
      if (data && data.appImages && data.appImages.data) {
        data.appImages.data.forEach((item) => {
          appImages[item.attributes.section] =
            item.attributes.media_file.data.attributes.url;
          details[item.attributes.section] = item.attributes.description;
        });
        setAppImagesData(appImages);
        setSectionDetails(details);
      }
    };

    processAppImagesData();
  }, [data]);
  return [appImagesData, sectionDetails];
};

export default useAppImages;
